import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconInterior: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="interior">
    <path
      fillRule="evenodd"
      d="M7.08 3.4a2.1 2.1 0 1 0 0 4.2h1.838a2.1 2.1 0 0 0 0-4.2H7.08Zm-.854 2.385A.9.9 0 0 1 7.08 4.6h1.838a.9.9 0 0 1 0 1.8H7.08a.9.9 0 0 1-.854-.615ZM3.35 16.24l.778-4.667A2.6 2.6 0 0 1 6.693 9.4h10.612a2.6 2.6 0 0 1 2.564 2.173l.778 4.667a2.6 2.6 0 0 1-1.914 4.36H5.264a2.6 2.6 0 0 1-1.913-4.36Zm3.343-5.64h2.658l-.37 4.8H4.708l.605-3.63a1.4 1.4 0 0 1 1.381-1.17Zm-1.429 6a1.4 1.4 0 1 0 0 2.8H7.45a1.604 1.604 0 0 1-.05-.4v-1.5c0-.322.072-.627.202-.9H5.264ZM9 19.4h6a.4.4 0 0 0 .4-.4v-1.5a.9.9 0 0 0-.9-.9h-5a.9.9 0 0 0-.9.9V19c0 .221.179.4.4.4Zm7.55 0h2.184a1.4 1.4 0 0 0 0-2.8h-2.336c.13.273.202.578.202.9V19c0 .139-.017.273-.05.4Zm2.742-4-.605-3.63a1.4 1.4 0 0 0-1.381-1.17H14.65l.4 4.8h4.24Zm-8.736-4.8-.37 4.8h3.662l-.4-4.8h-2.892ZM15.08 3.4a2.1 2.1 0 0 0 0 4.2h1.838a2.1 2.1 0 1 0 0-4.2H15.08Zm-.854 2.385A.9.9 0 0 1 15.08 4.6h1.838a.9.9 0 1 1 0 1.8H15.08a.9.9 0 0 1-.854-.615Z"
      clipRule="evenodd"
    />
  </Icon>
);
